//示例，根据项目修改或重新创建
import https from "../https";
import config from "@/config";

export default {
  visitLog(params) {
    return https.get(`${config.baseUrl}/visit_log`, params);
  }
};